<template>
  <div class="mb-3 mt-4">
    <w-title :text="title" :dark="bgIsDark"></w-title>
    <v-breadcrumbs
        v-if="breadcrumbs && breadcrumbs.length"
        :dark="bgIsDark"
        class="pl-1 pt-1"
        :items="breadcrumbs"
        divider=">" />
  </div>
</template>

<script>
import WTitle from './WTitle.vue'
import UIMixin from "@/mixins/UIMixin";

export default {
  name: 'WMainTitle',
  mixins: [UIMixin],
  props: ['breadcrumbs', 'title'],
  components: {
    WTitle
  }
}
</script>